export const stripHtmlTags = (html) => {
    if (!html) return '';
    // Create a temporary element to decode HTML entities and strip tags
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
};

export const isAdmin = (user) => {
    const adminUserId = process.env.REACT_APP_ADMIN_USER_ID || 'adminUser123';
    return user?.uid === adminUserId;
};

export const getRandomTip = () => {
    const tips = [
        "A Master Guide leads by example, showing Christ's love in every action.",
        "Remember: 'By the grace of God, I will be pure, kind, and true.'",
        "The Pathfinder Law is not just words, but a way of life.",
        "Prayer is the breath of the soul - make it a daily habit.",
        "Study your Bible truths regularly to strengthen your faith.",
        "A cheerful heart makes the journey more joyful for everyone.",
        "Leadership is about serving others, not being served.",
        "Every challenge is an opportunity to grow in character.",
        "The love of Christ compels us to be His hands and feet.",
        "Walk softly in nature and let creation teach you about God."
    ];
    return tips[Math.floor(Math.random() * tips.length)];
};
